<template>
    <div class="preview-text-message">
        <PreviewAvatar />
        <div class="text-bubble-container">
            <div class="text-bubble">
                <p class="text-message">{{ text }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import PreviewAvatar from '../PreviewAvatar.vue';

export default {
  name: 'TextMessagePreview',
  components: {
    PreviewAvatar
  },
  props: {
    text: {
      type: String,
      required: true,
    }
  },
};
</script>

<style lang="scss" scoped>
.preview-text-message {
    .text-bubble-container{
        position: relative;
        top: -14px;
        padding-left: 40px;
        .text-bubble {
            background: #F5F6FA;
            color: #000;
            padding: 0.5rem 0.75rem;
            border-radius: 16px;
            max-width: fit-content;
            font-size: 14px;
            line-height: 1.4;
            word-wrap: break-word;
            position: relative;
            display: inline-block;
            .text-message{
                font-weight: 400;
                font-size: 14px;
                line-height: 150%;
                letter-spacing: 0px;
                color:#4B5178;
                margin-bottom: 0px;
                white-space: pre-wrap;
            }
        }
        /* Tail pointer */
        .text-bubble::before {
            content: "";
            position: absolute;
            top: 4px;
            left: -13px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-right-color: #F5F6FA;
            border-top: none;
            -webkit-transform: rotate(45deg);
            transform: rotate(15deg);
        }
    }
}
</style>
